/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_DeviceInputs */

const en_ui_laps_device = /** @type {(inputs: Ui_Laps_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device laps`)
};

const de_ui_laps_device = /** @type {(inputs: Ui_Laps_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geräterunden`)
};

/**
* | output |
* | --- |
* | "Device laps" |
*
* @param {Ui_Laps_DeviceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_device = /** @type {((inputs?: Ui_Laps_DeviceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_DeviceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_device(inputs)
	return de_ui_laps_device(inputs)
});